import { createSlice } from "@reduxjs/toolkit";

import { setCalculationData } from "./actions";

const initialState = {
  data: null,
};

const calculationSlice = createSlice({
  name: "calculation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setCalculationData, (state, action) => {
      state.data = action.payload;
    });
  },
});

export default calculationSlice.reducer;
